'use strict';

module.exports = require('../services/createErrorClass')({
	name: 'SubUserHasNoPasswordError',
	message:
		'That account does not have a password set yet. Please follow the billing link we have emailed to you to access the account.'
});
